import { createSlice } from '@reduxjs/toolkit';
import { VitaminsState } from './VitaminsTypes';
import {
  requestVitaminPlanOperation,
  getLatestVitaminPlanOperation,
  getVitaminPlanByIdOperation,
  getOrRequestLatestVitaminPlanOperation,
} from './vitamins-operations';

const initialState: VitaminsState = {
  plan: null,
  latest: [],
  loadingPlan: false,
  error: null,
};

const vitaminsSlice = createSlice({
  name: 'vitamins',
  initialState,
  reducers: {
    resetVitaminsState: () => initialState,
  },
  extraReducers: builder => {
    /* ---------- запрос на генерацию ---------- */
    builder.addCase(requestVitaminPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(requestVitaminPlanOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(requestVitaminPlanOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    /* ---------- последний план ---------- */
    builder.addCase(getLatestVitaminPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getLatestVitaminPlanOperation.fulfilled, (s, { payload }) => {
      s.latest = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getLatestVitaminPlanOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    builder.addCase(getOrRequestLatestVitaminPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getOrRequestLatestVitaminPlanOperation.fulfilled, (s, { payload }) => {
      s.latest = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getOrRequestLatestVitaminPlanOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    /* ---------- план по request_id ---------- */
    builder.addCase(getVitaminPlanByIdOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
    });
  },
});

export const { resetVitaminsState } = vitaminsSlice.actions;
export default vitaminsSlice.reducer;
